module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=TJ - Tajikistan.0e07ef40.svg";